export interface TrustFact {
  value: string;
  label: string;
}

export interface PricingRow {
  service: string;
  description: string;
  price: string;
}

export interface Portrait {
  src: string;
  name: string;
  role: string;
  quote: string;
}

export interface SiteContent {
  heroImage: string | null;
  trustFacts: { de: TrustFact[]; en: TrustFact[] };
  pricingRows: PricingRow[];
  portrait: Portrait | null;
  showCaseStudies: boolean;
}

export const siteContent: SiteContent = {
  heroImage: null,
  trustFacts: {
    de: [
      { value: 'WKO', label: 'Mitglied der Wirtschaftskammer Österreich' },
      { value: 'GISA', label: 'Gewerberechtigung registriert, GISA-Zahl 39468772' },
      { value: 'Wien', label: 'Büro in Wien-Favoriten, Moselgasse 26' },
      { value: '30 Min.', label: 'Kostenloses, unverbindliches Erstgespräch' },
    ],
    en: [
      { value: 'WKO', label: 'Member of the Austrian Economic Chamber (WKO)' },
      { value: 'GISA', label: 'Registered trade licence, GISA number 39468772' },
      { value: 'Vienna', label: 'Office in Vienna-Favoriten, Moselgasse 26' },
      { value: '30 min.', label: 'Free, non-binding initial consultation' },
    ],
  },
  pricingRows: [],
  portrait: null,
  showCaseStudies: true,
};
